import React, { useContext } from "react";
import "./style.css";
import {
  FaGithub,
  FaTwitter,
  FaFacebookF,
  FaLinkedin,
  FaYoutube,
  FaTwitch,
  FaInstagram,
  FaSnapchatGhost,
  FaTiktok,
  FaCircle
} from "react-icons/fa";
import { socialprofils } from "../../content_option";
import { LanguageContext } from '../../data/language_context';

// Helper function to get follow text based on language
const getFollowText = (language) => {
  switch (language) {
    case "Spanish":
      return "Seguidnos";
    case "Catalan":
      return "Seguiu-nos";
    case "English":
    default:
      return "Follow Us";
  }
};

const ICON_MAPPING = {
  default: FaCircle,
  facebook: FaFacebookF,
  github: FaGithub,
  instagram: FaInstagram,
  linkedin: FaLinkedin,
  snapchat: FaSnapchatGhost,
  tiktok: FaTiktok,
  twitter: FaTwitter,
  twitch: FaTwitch,
  youtube: FaYoutube
};

export const Socialicons = (params) => {
  const { language } = useContext(LanguageContext);
  
  return (
    <div className="stick_follow_icon">
      <p>{getFollowText(language)}</p>
      <ul>
        {Object.entries(socialprofils).map(([platform, url]) => {
          const IconComponent = ICON_MAPPING[platform] || ICON_MAPPING.default;
          return (
            <li key={platform}>
              <a href={url} target="_blank" rel="noopener noreferrer">
                <IconComponent />
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
